import { useMessage } from '@hooks/useMessage'
import { useEffect, useState } from 'react'
import { AxiosResponse } from 'axios'
import axiosInstance from '@config/axios'
import { serverPath } from '@constants/api-endpoints'
import { errorMapper } from '@utils/errorMapper'
import { ErrorMessages } from '@constants/errors'
import { IPagination, ISort } from '@utils/sort'
import { TableDataResponse } from '@interfaces/table.interface'
import { IStarUserTable } from '@dto/mainStat/mainStat.dto'

interface IProps {
  dates: string[] | 'all'
  id: string[] | 'all'
  sort?: ISort
  pagination?: IPagination
  isAllCrms?: boolean
}
interface IHookResponse extends TableDataResponse<IStarUserTable> {
  isLoading: boolean
}

export const useGetUserList = ({
  dates,
  id,
  pagination,
  sort,
  isAllCrms,
}: IProps): IHookResponse => {
  const { error } = useMessage()
  const [result, setResult] = useState<TableDataResponse<IStarUserTable>>({
    count: 0,
    rows: [],
  })

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!dates || !id || !id?.length) return
    const getData = async () => {
      try {
        setIsLoading(true)
        const {
          data,
        }: AxiosResponse<TableDataResponse<IStarUserTable> & { countUserOnline: number }> =
          await axiosInstance.get(serverPath.CRM_USERS, {
            params: {
              dates: !dates.length || dates === 'all' ? null : [dates[0], dates[1]],
              id: isAllCrms ? [] : id,
              pageSize: pagination ? pagination.pageSize : null,
              page: pagination ? pagination.current : null,
              sort: sort ? sort.sort : null,
              field: sort ? sort.field : null,
            },
          })
        setResult(data)
      } catch (e) {
        error(errorMapper(ErrorMessages.GET_DATA, e), ErrorMessages.SERVER_ERROR)
      } finally {
        setIsLoading(false)
      }
    }
    getData().then()
  }, [id, dates, pagination, sort, isAllCrms])

  return {
    rows: result.rows,
    isLoading,
    count: result.count,
  }
}
